// @/services/QuizzesClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const quizzesOptions = {
  baseUrl: `${BACK_END_URL}/quiz`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class QuizzesClient extends CandyClient {
  constructor() {
    super(quizzesOptions);
  }
  
    async getQuizById(quizId) {
      return this.get(`/id/${quizId}`);
    }

  // Create
  async createQuiz(quizData) {
    return this.post("/create/", quizData);
  }

  // Get all lessons for a chapter
  async getAllQuizzesByChapter(chapterId) {
    return this.get(`/list/${chapterId}`);
  }

  // Update
  async updateQuiz(quizId, quizData) {
    return this.put(`/update/${quizId}`, quizData, {
      customHeaders: { 
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      }   
    });    
  }

  // Delete
  async deleteQuiz(quizId) {
    return this.delete(`/delete/${quizId}`, null, {
      customHeaders: { Authorization: `Bearer ${getToken()}` },
    });  }


}
